// extracted by mini-css-extract-plugin
module.exports = {"doughProPayments":"DoughProPayments_doughProPayments__AguIR"};